/* eslint-disable */
export enum RootPages {
  def="/",
  login="/login", // If this is changed to not include the / hard navigate to login function needs to be updated
  userInformations="/userInformations",
  error="/error",
}

export enum GlobalMenu_Pages {
  home="./",

  dashboard = "dashboard",

  kpi = "kpi",

  feedCurves = "feed curves",
  components = "components",
  componentsAlternatives = "component alternatives",
  mixtures = "mixtures",
  feedCurve = "feed curve",

  silos = "silos",
  silosSettings = "silo settings",

  animals = "animals",
  animalsGroups = "animal groups",
  animal = "animal",

  reports="reports",
  report="report",
  archive="archive",

  logbook="logbook",
  
  globalSettings="globalsettings",
  devices = "devices",
  integrations = "integrations"
}

export enum SystemMenu_Pages {
  home="./",

  autopig="autopig",
  Autopig_settings="settings",

  freeda_lf="lf",
  freeda_lf_sections="lf locations",
  // freeda_lf_section="section",
  freeda_lf_settings = "lf settings",
  
  freeda_esf = "esf",
  freeda_esf_sections = "esf locations",
  freeda_esf_settings = "esf settings"
}

export enum focus_viewMenu_Pages {
  home="./",
  op_operations="op_operations",
  op_animals = "op_animals",
  op_quickEntry = "op_quickentry",
  op_freeda_lf = "op_freeda_lf",
}

export enum ToolsMenu_Pages {
  home = "./",

  tools_aico = "aico",
  tools_log = "log",
  
  tools_config = "config",

  tools_firmware = "lc firmware",
  tools_firmwareIO = "io firmware",

  tools_deviceDataTables = "device data",
  tools_terminal = "terminals",
  tools_feedDays = "feed days",
  tools_feedTimes = "feed times",
  tools_devices = "devices",
  tools_feedCurves = "feed curves",
  tools_systems = "systems",
  tools_queue_list = "queues",
  tools_queue = "queue",
  tools_actions = "actions",
  tools_stations = "stations",

  tools_companies = "companies",
  tools_createCompany = "create company",
  tools_company = "company",

  tools_users = "users",

  tools_graphQL = "graphQL",

  tools_server = "server",
  tools_connected_1801 = "connected 1801"

}
/* eslint-enable */